import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { LSRW } from '../../utils/const';
import { tagEvent } from '../../utils/tagManager';
import {
	fetchAttempt,
	setShowTestInstr,
} from '../../redux/myCourse/myCourse.actions';
import {
	startAttempt,
	toggleMicPermission,
} from '../../redux/testPage/testPage.actions';
import Modal from 'react-bootstrap/Modal';
import { setSpeechStatus } from '../../redux/utilities/utils.actions';
import { recordAudio, sleep, isIos } from '../../utils/commonFunctions';
import UserTypes from '../../utils/userTypes';
import Config from '../../config/Config';
import $ from 'jquery';
import Loader from '../../utils/Loader';
import { continuousVisualizer, currentVisualizer } from 'sound-visualizer';

const TestInstruction = React.memo(function TestInstruction({
	instrDetails,
	fetchAttempt,
	startAttempt,
	toggleMicPermission,
	showTestInstr,
	setShowTestInstr,
	showReview,
	hideSpeakTest,
	userType,
	product_id,
	product_name,
	userId,
	course_name,
	isMicPermitted
}) {

	const [showPlayerTag, setShowPlayerTag] = useState(false);
	const [activeInstrTab, setActiveInstrTab] = useState('step-1');
	const [agreeInstructions, setAgreeInstructions] = useState(false);
	const recordButtonRef = useRef(null);
	const stepOneNextButton = useRef(null);

	const {
		domain,
		domains,
		hideStart,
		attemptRemaning,
		elementId,
		elementType,
		continueAttemptId,
		unitName,
		courseId,
		totalQuestion,
		sumTimeLimit,
		elementName,
		reviewAttemptId,
		previewMode,
	} = instrDetails;

	const currentVisual = document.getElementById("currentVisual");

	const handleClickAction = (event) => {
		event.currentTarget.disabled = true;
		// Loader.show()
		event.stopPropagation()
	}

	isMicPermitted = (courseId == 620 || courseId == '620') ? true : isMicPermitted

	var domainList = '';
	if ((!!domain || !!domains) && localStorage.getItem('active_course_id') !== '652' && localStorage.getItem('active_course_id') !== '653' && localStorage.getItem('active_course_id') !== '658' && localStorage.getItem('active_course_id') !== '659' && localStorage.getItem('active_course_id') !== '669') {
		domainList = domain.split('|').map(function (key) {
			return (
				<li key={key}>
					<img
						src={Config.ASSETSPATH + 'img/' + LSRW[key] + '.png'}
						title={LSRW[key + 'T']}
					/>
				</li>
			);
		});
	} else {
		domainList = domains.map(function (key) {
			return (
				<li key={key}>
					<img
						src={Config.ASSETSPATH + 'img/' + key + '_B.png'}
						title={key}
					/>
				</li>
			);
		});
	}

	const [isSpeechAvail, setIsSpeechAvail] = useState(false);
	useEffect(() => {
		setIsSpeechAvail(false);
		domains.forEach((domain) => {
			let result = domain.replace(/^\s+|\s+$/gm, '');
			if (result === 'Speaking') {
				setIsSpeechAvail(true);
				setActiveInstrTab('step-1')
			}
		});
		if (!isSpeechAvail) {
			setActiveInstrTab('step-2')
		}

	}, [domains, isSpeechAvail]);

	const [iosAudioURL, setiosAudioURL] = useState('');
	let audio = {};
	const isMounted = useRef(true);

	const retryRecording = () => {
		if (Object.keys(audio).length > 0) {
			audio.pause();
		}
		document.getElementById('recordFail').style.display = 'block';
		document.getElementById('beforeStart').style.display = 'block';
		document.getElementById('afterStart').style.display = 'none';
		Loader.hide()
	};

	const handleAction = async () => {
		isMounted.current = true;
		recordButtonRef.current.classList.add("recording-in-progress")
		
		const recorder = await recordAudio();
		recorder.start();

		const { start, stop, reset } = continuousVisualizer(recorder.getStream(), currentVisual, {
			lineWidth: "thick",
			strokeColor: "#FFFFFF"
		});
		start();

		// document.getElementById('beforeStart').style.display = 'none';
		// document.getElementById('whileRecording').style.display = 'block';
		// document.getElementById('recordFail').style.display = 'none';
		await sleep(6000);
		audio = await recorder.stop();
		reset()
		recordButtonRef.current.classList.remove("recording-in-progress", "fa-microphone", "fa-redo")
		recordButtonRef.current.classList.add("fa-redo")
		stepOneNextButton.current.classList.remove("btn-disabled")

		if (isMounted.current) {
			// document.getElementById('whileRecording').style.display = 'none';
			// document.getElementById('afterStart').style.display = 'block';

			document.getElementById('audioPlayer').src = audio.audioUrl;
			setShowPlayerTag(true)
			setSpeechStatus()
			
			// if (isIos()) {
				// document.getElementById('audioTestID').src = audio.audioUrl;
				// setiosAudioURL(audio.audioUrl)
			// } else {
			// 	audio.play();
			// }

			// if (!isIos()) {
			// 	audio.play();
			// }
		}
		Loader.hide()
	};

	const setSpeechActive = () => {
		toggleMicPermission(true);
		//setSpeechStatus()
		// document.getElementById('recordSuccess').style.display = 'block';
		// document.getElementById('afterStart').style.display = 'none';
		if (Object.keys(audio).length > 0) {
			audio.pause();
		}
		Loader.hide()
	};

	const startTestTag = () => {
		if (previewMode) {
			localStorage.setItem('previewWebisodeStart', new Date());
			tagEvent({
				event: 'start_course_preview',
				user_id: userId,
				course_id: courseId,
				grant_name: course_name,
				product_id,
				product_name,
				platform: 'web',
			});
		}
	};

	const instrNavigation = (num) => {
		if(num === '2') {
			setSpeechActive()
		}
		setActiveInstrTab('step-' + num)
		Loader.hide()
	}

	const agreeCheckboxChange = (event) => {
		setAgreeInstructions(event.target.checked)
	}
	
	if (localStorage.getItem('disableTemplate') == '1' && localStorage.getItem('active_course_id') !== '652' && localStorage.getItem('active_course_id') !== '653' && localStorage.getItem('active_course_id') !== '658' && localStorage.getItem('active_course_id') !== '659' && localStorage.getItem('active_course_id') !== '669') {
	// if (localStorage.getItem('disableTemplate') == '1') {
		// $('.body-container').css('opacity', '1');
		// $('.step-def-header, .step-container').hide();
		// $('.modal-header button.close').hide();
	}

	return (
		<>
			<div className={`testInstructionContainer ${showTestInstr ? 'active' : ''}`}>
				{!hideSpeakTest && isSpeechAvail && (
					<div className={`recordingBox recording-step-1 ${activeInstrTab === 'step-1' && continueAttemptId === 0 ? 'active' : ''}`}>
						<a className='setShowTestInstr' onClick={() => setShowTestInstr(false)}>&times;</a>
						<h2 className='recording-title'>Let's test your audio input and output.</h2>
						<div className="container-audio">
							<canvas id="currentVisual" width="75" height="75" />
							<i className="fas fa-microphone" id="recordButton" aria-hidden="true" ref={recordButtonRef} onClick={(e) => {
								handleClickAction(e);
								handleAction()
							}}></i>
						</div>
						<div className="vol-con">
							<span className={`micInfo ${!showPlayerTag ? 'show' : ''}`}>Please ensure MIC volume is high</span>
							<div id="volume-visualizer" className={showPlayerTag ? 'show' : ''}>
								<audio controls id="audioPlayer"></audio>
							</div>
						</div>
						<div className="but">
							<button
								aria-label="Start"
								id="stepOneNextButton"
								ref={stepOneNextButton}
								type="button"
								className="btn btn-lg btn-info go-next btn btn-primary btn-disabled"
								aria-required="true"
								onClick={(e) => {
									handleClickAction(e);
									instrNavigation('2');
								}}
							>Next</button>
						</div>
					</div>
				)}

				<div className={`recordingBox recording-step-2 ${activeInstrTab === 'step-2' && continueAttemptId === 0 ? 'active' : ''}`}>
					<a className='setShowTestInstr' onClick={() => setShowTestInstr(false)}>&times;</a>
					<h2 className='recording-title'>Instructions</h2>
					<ul className="instruction-list">
						<li className="transition-item">Your audio and recording check were successful. Please ensure you do not mute the MIC or adjust any audio/MIC settings till your test is complete.</li>
						<li className="transition-item">Ensure you have a stable and reliable internet connection till your test is complete.</li>
						<li className="transition-item">Please take the test in a quiet room with no background noises.</li>
					</ul>
					<div className="agreeInstructions-cbox transition-item">
						<input type="checkbox" id="agreeInstructions" onChange={agreeCheckboxChange} />
						<label htmlFor="agreeInstructions"><p>I have read and understood the instructions.</p></label>
					</div>
					<div className="but">
						<button
							aria-label="Start"
							type="button"
							className={`btn btn-lg btn-info go-next btn btn-primary ${!agreeInstructions ? 'btn-disabled' : ''}`}
							aria-required="true"
							onClick={(e) => {
								handleClickAction(e);
								instrNavigation('3');
							}}
						>Next</button>
					</div>
				</div>

				<div className={`recordingBox recording-step-3 ${activeInstrTab === 'step-3' || continueAttemptId !== 0 ? 'active' : ''}`}>
					<a className='setShowTestInstr' onClick={() => setShowTestInstr(false)}>&times;</a>
					<p className='test-infor transition-item'>Test Duration<span>{courseId == '669' ? '30' : sumTimeLimit} minutes</span></p>
					{/* <p className='test-infor'>Questions<span>{totalQuestion}</span></p> */}
					<p className='test-infor transition-item'>Questions<span>{totalQuestion}</span></p>
					<div className="but">
						{!(!!attemptRemaning && !!hideStart) && !continueAttemptId && (
							<button
								aria-label="Start"
								type="button"
								className="btn btn-lg btn-info go-next btn btn-primary"
								aria-required="true"
								onClick={(e) => {
									handleClickAction(e);
									startTestTag();
									startAttempt(courseId, elementId);
								}}
							>Start</button>
						)}
						{!!continueAttemptId && (
							<button
								aria-label="Continue"
								type="button"
								className="btn btn-lg btn-info go-next btn btn-primary mar-left"
								aria-required="true"
								onClick={(e) => {
									handleClickAction(e);
									startTestTag();
									fetchAttempt(continueAttemptId);
								}}
							>Continue</button>
						)}
					</div>
				</div>

			</div>
		</>
	);

});

const mapStateToProps = (state) => {
	const { coursedetails: { course_name } = {} } = state.rootReducer.myCourse;
	const { isMicPermitted } = state.rootReducer.testPageDetails;
	const { userId, enableProctor } = state.rootReducer.loginDetails;
	const {
		productData: { product_id, product_name } = {},
	} = state.rootReducer.buyCourse;
	return {
		instrDetails: state.rootReducer.myCourse,
		showTestInstr: state.rootReducer.myCourse.showTestInstr,
		showReview: state.rootReducer.testPageDetails.showReview,
		userType: state.rootReducer.loginDetails.userType,
		product_id,
		product_name,
		course_name,
		isMicPermitted,
		userId,
		enableProctor,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchAttempt: (attemptId, review = false) =>
			dispatch(fetchAttempt({ attemptId, review })),
		startAttempt: (courseId, elementId) =>
			dispatch(startAttempt({ courseId, elementId })),
		setSpeechStatus: () => dispatch(setSpeechStatus()),
		toggleMicPermission: (val) => dispatch(toggleMicPermission(val)),
		setShowTestInstr: (val) => dispatch(setShowTestInstr(val)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(TestInstruction);
